const config = {
  portfolio: {
    portfolioLogo: 'Portfolio',
    projectCard: {
      cards: [
        {
          heading: 'Halawiyet Omfadila',
          description: 'A dynamic website for a Tunisian pastry shop with features like user accounts, admin dashboard, and a database.',
          animationDelay: '300',
          buttonLink: 'https://github.com/marambelhouchet/halawiyetomfadila',
          buttonText: 'See Project',
        },
        {
          heading: 'Simple Java Project',
          description: 'A simple Java project showcasing interfaces for both admin and user roles, with a database backend.',
          animationDelay: '500',
          buttonLink: 'https://github.com/marambelhouchet/javaprojetds',
          buttonText: 'See Project',
        },
        {
          heading: 'Crime Prediction with Python',
          description: 'An analysis project where I cleaned a large dataset using CRISP-DM methodology and created a crime prediction model for America.',
          animationDelay: '700',
          buttonLink: 'https://github.com/marambelhouchet/CRIMESPREDUCTION ',
          buttonText: 'See Project',
        },
        {
          heading: 'R Project',
          description: 'An R project involving data cleaning, visualization, and crime prediction modeling.',
          animationDelay: '900',
          buttonLink: 'https://github.com/marambelhouchet/projetR ',
          buttonText: 'Explore Project',
        },
        {
          heading: 'Web Scraping',
          description: 'A project focused on web scraping.',
          animationDelay: '1100',
          buttonText: 'View Code',
          buttonLink: 'https://github.com/marambelhouchet/webscrapinglvl2',
        },
        {
          heading: 'Recti App',
          description: 'An Android mobile app developed using Android Studio, SQLite, and Firebase. The app provides recipes from all around the world.',
          animationDelay: '1300',
          buttonLink: 'https://github.com/marambelhouchet/recetiapp',
          buttonText: 'See code',
        },
      ],
    },
  },
};

export default config;

